import { useState } from 'react'

import { IconButton, Tooltip } from '@material-ui/core'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import DeleteIcon from '@material-ui/icons/Delete'
import EditContextProvider from 'Components/Hooks/ContextEdit'
import SetState from 'Components/Hooks/SetState'
import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import MuiDatables from 'Components/UI/Atoms/Table'
import AutocompleteFilter from 'Components/UI/Atoms/Table/Autocomplete'
import CancelConfirmButtons from 'Components/UI/Molecules/CancelConfirmButtons'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'
import { RECEIPT_STATE, SUCURSAL_ORIGEN } from 'Constants'
import { interfaces } from 'service/interfaces'

import PaymentOrderEdit from './Edit'

const PaymentOrdersTable = (props) => {
  const { render, setRender, permissions, dataBefore } = props

  const windowSize = useMediaQuery('(min-width:1000px)')
  const [loading, setLoading] = useState(false)
  const createDismissableSnackbar = useCustomSnackbar()

  const { state, setOpen, setClose } = SetState()
  const { state: stateDelete, setOpen: setOpenDelete, setClose: setCloseDelete } = SetState()
  const [deleteIndex, setDeleteIndex] = useState(null)

  const [values, setValues] = useState({
    rows: [],
    header: 0,
    permissions: {},
  })

  async function apiCall(options, callback) {
    setValues({
      rows: [],
      header: [],
      permissions: {},
    })

    try {
      // Agregar filtro por defecto de modalidad = ventas
      const queryString = options ? `${options}&modalidad=ventas` : 'modalidad=ventas'
      const result = await interfaces.salesPaymentOrders.list(queryString, 1)
      setValues({
        rows: result.data.data,
        header: result.header.header.count,
        permissions: result.data.permissions,
      })
    } catch (e) {
      setValues({
        rows: [],
        header: [],
        permissions: {},
      })
    } finally {
      callback()
    }
  }

  async function paymentOrderInfo(id, origen) {
    const empresaId = SUCURSAL_ORIGEN.find((sucursal) => sucursal.label === origen).id
    await interfaces.salesPaymentOrders.getOneForEdit(id, empresaId).then((res) => {
      setOpen({
        data: res.data,
      })
    })
  }

  const handleConfirmDelete = async () => {
    if (deleteIndex === null || deleteIndex === undefined) return
    setLoading(true)
    const rowToDelete = values.rows[deleteIndex]
    const origenLabel = SUCURSAL_ORIGEN.find(
      (sucursal) => sucursal.label === rowToDelete.origen.toUpperCase()
    )
    const empresaId = origenLabel ? origenLabel.id : null

    await interfaces.salesPaymentOrders
      .deletePaymentOrder(rowToDelete.id, empresaId)
      .then((res) => {
        createDismissableSnackbar(res.data, {
          variant: 'success',
        })
        setRender(!render)
      })
      .catch((err) => {
        createDismissableSnackbar(err.response.data.data, {
          variant: 'error',
        })
      })
    setLoading(false)
    setDeleteIndex(null)
    setCloseDelete()
  }

  const actions = (file) => {
    return (
      <div style={{ display: 'flex', marginLeft: '0.3rem' }}>
        <Tooltip title="Eliminar">
          <IconButton
            onClick={(e) => {
              e.stopPropagation()
              setDeleteIndex(values.rows.indexOf(file))
              setOpenDelete(true)
            }}
            size={windowSize ? 'medium' : 'normal'}
            disabled={file.estado === 'Borrador' ? false : true}
            style={{
              color: file.estado === 'Borrador' ? 'rgb(186, 79, 72)' : '#e0e0e0',
            }}
          >
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </div>
    )
  }

  const RowsTransit = () =>
    values.rows.map((row) => [
      row.origen,
      row.fecha_creacion,
      row.usuario,
      row.nro_comprobante,
      row.cliente,
      row.monto ? `$${parseFloat(row.monto)}` : '$',
      row.estado,
      actions(row),
      '',
    ])

  const columns = [
    {
      name: 'origen',
      label: 'Origen',
      options: {
        filter: true,
        sort: false,
        sortThirdClickReset: true,
        filterType: 'custom',
        filterOptions: {
          display: (filterList, onChange, index, column) => {
            if (Object.keys(dataBefore).length > 0) {
              return (
                <AutocompleteFilter
                  filterList={filterList}
                  onChange={onChange}
                  index={index}
                  column={column}
                  label="Origen"
                  filterName="label"
                  options={SUCURSAL_ORIGEN}
                  defaultOption={{ label: 'ECO', id: 1 }}
                  fullWidth={true}
                />
              )
            }
          },
        },
      },
    },
    {
      name: 'fecha_creacion',
      label: 'Fecha creación',
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: 'usuario',
      label: 'Usuario',
      options: {
        filter: true,
        sort: false,
        sortThirdClickReset: true,
        filterType: 'custom',
        filterOptions: {
          display: (filterList, onChange, index, column) => {
            if (Object.keys(dataBefore).length > 0) {
              return (
                <AutocompleteFilter
                  filterList={filterList}
                  onChange={onChange}
                  index={index}
                  column={column}
                  label="Usuario"
                  filterName="fullName"
                  options={dataBefore.data.usuarios}
                  fullWidth={true}
                />
              )
            }
          },
        },
      },
    },
    {
      name: 'nro_comprobante',
      label: 'N° comprobante',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'cliente',
      label: 'Cliente',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'monto',
      label: 'Monto',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'estado',
      label: 'Estado',
      options: {
        filter: true,
        sort: false,
        sortThirdClickReset: true,
        filterType: 'custom',
        filterOptions: {
          display: (filterList, onChange, index, column) => {
            return (
              <AutocompleteFilter
                filterList={filterList}
                onChange={onChange}
                index={index}
                column={column}
                label="Estado"
                filterName="label"
                options={RECEIPT_STATE}
                fullWidth={true}
              />
            )
          },
        },
      },
    },
    {
      name: '',
      label: '',
      options: {
        filter: false,
        sort: false,
      },
    },
  ]

  return (
    <>
      {state.suspense && (
        <EditContextProvider>
          <PaymentOrderEdit
            open={state.open}
            handleclose={setClose}
            data={state.data}
            setRender={setRender}
            render={render}
            permissions={permissions}
            setLoading={setLoading}
            loading={loading}
          />
        </EditContextProvider>
      )}
      {stateDelete.suspense && (
        <DialogComponent
          open={stateDelete.open}
          handleclose={setCloseDelete}
          widthLarge={500}
          title="¿Desea eliminar la orden de pago?"
          subtitle="¡Esta acción es irreversible!"
          disableChildHeight
          disableBackdropClick
          disableEscapeKeyDown
          actions={
            <CancelConfirmButtons
              onClickSubmit={handleConfirmDelete}
              onClickCancel={() => {
                setDeleteIndex(null)
                setCloseDelete()
              }}
              isLoading={loading}
              disabledSubmit={loading}
            />
          }
        />
      )}
      <MuiDatables
        columns={columns}
        data={RowsTransit()}
        title={`Cantidad de ordenes de pago: ${values.header}`}
        apiCall={apiCall}
        count={values.header}
        render={render}
        setRender={setRender}
        textPlaceholder="Buscar por cliente o N° comprobante..."
        onRowClick={(_, index) =>
          paymentOrderInfo(values.rows[index.dataIndex].id, values.rows[index.dataIndex].origen)
        }
        padding={windowSize ? '10px' : ''}
      />
    </>
  )
}

export default PaymentOrdersTable
